module.exports = __webpack_public_path__ + "img/432-2f5781.png";